import { render, staticRenderFns } from "./RuleDefinitionForm.vue?vue&type=template&id=07cb4e1c&"
import script from "./RuleDefinitionForm.vue?vue&type=script&lang=js&"
export * from "./RuleDefinitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports